<template>
  <div class="partnerBlock">
    <!--img src="./../assets/img/vives.svg" class="logopartner" /-->
    <div v-html="tekst"></div>
  </div>
</template>


<script>
export default {
  props: {
    tekst: String,
    logo: String
  }
};
</script>

<style>
.partnerBlock {
  margin-bottom: 3rem;
}
.logopartner {
  height: 77px;
}
</style>

